export enum NotificationComponentKey {
    PAYMENT_SUCCESS = 'positive-notification-web',
    PAYMENT_ERROR = 'error-notify-section-web',
    PAYMENT_ACCEPT = 'payment-accept-notification',
    AUTHORIZATION_INSURER_DATA = 'insurer-data-authorization',
    REGISTRATION_FAILED = 'insurer-failed-data-authorization',
    NEXT_SUCCESS = 'next-success-notification',
    CONNECTION_ERROR = 'connection-error-notification-web',
    ERROR = 'error-notification-web',
    SESSION_ERROR = 'session-error-notification-web',
}

export enum SectionComponentKey {
    INSURER_DATA = 'insurer-data-section',
    AGREEMENTS = 'agreements-section',
    MOBILE_SELECTED_OFFER = 'mobile-selected-offer-section',
    SELECTED_OFFER = 'selected-offer-section',
    OFFER = 'offer-section',
    NEXT_OFFERS = 'next-offers-section',
    OFFER_RECOMMENDATIONS = 'offer-recommendations-section',
    METHOD_PAYMENTS = 'method-payments-section',
    NEXT_PAYMENT_METHOD = 'next-payment-method-section',
    VEHICLE_USE = 'vehicle-use-section',
    VEHICLE_DATA = 'vehicle-data-section',
    SALES_MESSAGES = 'sales-messages-section',
    ADDITIONAL_CONTENT = 'additional-content-section',
    OWNER_DATA = 'owner-data-section',
    INFORMATION = 'information-section',
    INITIAL_DATA = 'initial-data-section',
    CALCULATION_AGREEMENTS = 'calculation-agreements-section',
    VEHICLE_MODEL = 'vehicle-model-section',
    ADDITIONAL_INFORMATION = 'additional-information-section',
    INSTALLMENT = 'installment-section',
    CESSION = 'cession-section',
    AZTEC = 'aztec-section',
    CONTACT_DATA = 'contact-data-section',
    CONTACT_INSURER_DATA = 'contact-insurer-data-section',
    INSURANCE_COVERAGES = 'insurance-coverages-section',
    INFORMATION_CLAUSE = 'information-clause-section',
    DISCOUNT_CODES = 'discount-codes-section',
    AC_VARIANTS = 'ac-variants-section',
    AC_VARIANTS_BEESAFE = 'ac-variants-beesafe-section',
    ADDITIONAL_OPTIONS = 'additional-options-section',
    ADDITIONAL_OPTIONS_BEESAFE = 'additional-options-beesafe-section',
    AXA_DISCOUNT_CODE = 'axa-discount-code-section',
    PERSONAL_DATA_ADMINISTRATOR = 'personal-data-administrator-section',
    POWER_OF_ATTORNEY = 'power-of-attorney-section',
    ADDITIONAL_DATA = 'additional-data-section',
    CALCULATIONS_CACHE = 'calculations-cache-section',
}
